export default {
  100: 'PayPending',
  101: 'paid',
  102: 'Sent',
  103: 'Delivered',
}
